var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-0.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    className: "cls-1",
    transform: "translate(0.217)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 48,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    transform: "translate(103.316 131.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    transform: "translate(-84.38 -120.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    className: "cls-2",
    d: "M-75.053-109.674a5.512,5.512,0,0,1-5.506-5.506,5.512,5.512,0,0,1,5.506-5.5,5.51,5.51,0,0,1,5.5,5.5A5.511,5.511,0,0,1-75.053-109.674Zm0-9.439a3.937,3.937,0,0,0-3.934,3.932,3.939,3.939,0,0,0,3.934,3.934,3.937,3.937,0,0,0,3.93-3.934A3.936,3.936,0,0,0-75.053-119.112Z",
    transform: "translate(80.559 120.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    transform: "translate(-89.098 -108.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    className: "cls-2",
    d: "M-69.439-90.055H-88.312a.786.786,0,0,1-.786-.786,7.084,7.084,0,0,1,7.077-7.076h6.291a7.085,7.085,0,0,1,7.077,7.076A.786.786,0,0,1-69.439-90.055Zm-18.029-1.573h17.187a5.512,5.512,0,0,0-5.448-4.717h-6.291A5.51,5.51,0,0,0-87.468-91.628Z",
    transform: "translate(89.098 97.918)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.ad4ed1d7.svg";
export { ForwardRef as ReactComponent };